import React from 'react';
import { NavLink } from 'react-router-dom';
import { LogOutIcon } from 'lucide-react';
import { adminNav } from '../../../data/adminNav';
import { AdminLogo } from './AdminLogo';
interface Props {
  newEnquiries: number;
  onNavigate?: () => void;
  onLogout: () => void;
  /** Erstatter logoet øverst (bruges til søgefeltet i mobilmenuen). */
  header?: React.ReactNode;
}
export function AdminSidebar({
  newEnquiries,
  onNavigate,
  onLogout,
  header
}: Props) {
  return <div className="flex h-full flex-col" data-id="element-395" data-mp="3nn6k5xqnvz7d">
      {header ?? <div className="flex h-16 items-center px-6" data-id="element-396" data-mp="3is11r8wgx2o1">
          <AdminLogo data-id="element-397" data-mp="19olwjxk7wph" />
        </div>}

      <nav aria-label="Adminnavigation" className="flex-1 overflow-y-auto px-3 pb-6 pt-3" data-id="element-398" data-mp="1bj6fx4x5mt1">
        {adminNav.map(section => <div key={section.title} className="mt-5 first:mt-0" data-id="element-399" data-mp="3smsx062kvdfn">
            <p className="px-3 pb-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-ink-faint" data-id="element-400" data-mp="34xgs3iea9rj5">
              {section.title}
            </p>
            <ul className="flex flex-col gap-0.5" data-id="element-401" data-mp="gzbm4lzu736h">
              {section.items.map(item => <li key={item.to} data-id="element-402" data-mp="lxwqmxm4g90q">
                  <NavLink to={item.to} end={item.end} onClick={onNavigate} className={({
              isActive
            }) => `group flex items-center gap-3 rounded-xl border px-3 py-2.5 text-[15px] transition-colors duration-150 ease-smooth ${isActive ? 'border-accent/40 bg-accent/15 font-medium text-ink' : 'border-transparent text-ink-soft hover:bg-white hover:text-ink'}`} data-id="element-403" data-mp="lwvdmnljpcgd">
                    {({
                isActive
              }) => <>
                        <item.icon className={`h-[18px] w-[18px] shrink-0 ${isActive ? 'text-accent' : 'text-ink-muted group-hover:text-ink-soft'}`} strokeWidth={1.75} aria-hidden="true" data-id="element-404" data-mp="1igkidbhz6uyb" />
                        <span className="flex-1" data-id="element-405" data-mp="3fgyrt63smbym">{item.label}</span>
                        {item.showEnquiryBadge && newEnquiries > 0 && <span className="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-danger px-1.5 text-[11px] font-semibold text-white" aria-label={`${newEnquiries} nye`} data-id="element-406" data-mp="3tf54mydhpb5s">
                            {newEnquiries}
                          </span>}
                      </>}
                  </NavLink>
                </li>)}
            </ul>
          </div>)}
      </nav>

      <div className="border-t border-line p-3" data-id="element-407" data-mp="2i1b79ymgcsfe">
        <button type="button" onClick={onLogout} className="flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-[15px] text-ink-soft transition-colors duration-150 ease-smooth hover:bg-white hover:text-ink" data-id="element-408" data-mp="2i001xudczcm6">
          <LogOutIcon className="h-[18px] w-[18px] text-ink-muted" strokeWidth={1.75} aria-hidden="true" data-id="element-409" data-mp="xam8lvd3jj28" />
          Log ud
        </button>
      </div>
    </div>;
}